import { inject } from '@angular/core';
import { Router, ResolveFn } from '@angular/router';
import { of, take } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { Feature } from '../common/models/Feature';
import { FeatureService } from '../common/services/feature.service';
import { AuthService } from '../centrui/src/app/services/auth.service';

export const featuresResolver: ResolveFn<Feature[]> = () => {
  const authService = inject(AuthService);
  const featureService = inject(FeatureService);
  const router = inject(Router);
  const customerId = authService.userObject?.customer_id;
  if (customerId == null) return of([]);
  if (featureService.consumeResolverSkip()) {
    return of([]);
  }
  return featureService.refresh(customerId).pipe(
    take(1),
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        router.navigate(['/login']);
      }
      return of([]);
    })
  );
};
